import React, { useState, useEffect, useContext } from "react";
import peij from "../../../services/peij";
import Form from "../../../components/form";
import AppContext from "../../../container/context";
import { formatDateTime } from "../../../helpers/helpers";
import { CircularProgress } from "@mui/material";
import modalidadeAssinatura from "../../../enums/modalidadeAssinatura";

const Promocao = ({ match, history }) => {
  const { notification } = useContext(AppContext);
  const promocaoChave = match.params.id;
  const [carregando, setCarregando] = useState(false);
  const [promocao, setPromocao] = useState({});

  useEffect(() => {
    if (promocaoChave !== "" && promocaoChave !== "0") {
      carregar();
    }
  }, [promocaoChave]);

  const carregar = () => {
    setCarregando(true);
    peij
      .post("assinaturas/carregarPromocao", { chave: promocaoChave })
      .then((promocao) => {
        setPromocao(promocao);
        setCarregando(false);
      })
      .catch((e) => {
        notification("error", "Não foi possível carregar a promoção");
        setCarregando(false);
      });
  };

  const formularioPromocao = (promocao) => ({
    chave: {
      label: "Chave",
      type: "text",
      value: promocao.chave,
      required: true,
      space: 4,
    },
    modalidadeAssinatura: {
      label: "Modalidade da assinatura",
      type: "select",
      domain: modalidadeAssinatura,
      value: promocao.modalidadeAssinatura,
      space: 4,
      emptyItem: true,
      emptyItemText: "(Selecione)",
      required: true,
    },
    validade: {
      label: "Validade",
      type: "date",
      value: promocao.validade
        ? formatDateTime(promocao.validade, "Y-M-D")
        : null,
      required: true,
      space: 4,
    },
    descricao: {
      label: "Descrição",
      type: "textarea",
      value: promocao.descricao,
    },
    valor: {
      label: "Valor R$",
      type: "number",
      value: promocao.valor,
      space: 6,
    },
    qtdParcelas: {
      label: "Máximo de Parcelas (promoções mod. pacote adquirido)",
      type: "number",
      value: promocao.qtdParcelas,
      space: 6,
    },
    idPlanoIugu: {
      label: "ID plano IUGU (promoções mod. recorrente)",
      type: "text",
      value: promocao.idPlanoIugu,
      space: 6,
    },
    mesesAssinatura: {
      label:
        "Meses de validade da assinatura (promoções mod. pacote adquirido)",
      type: "number",
      value: promocao.mesesAssinatura,
      space: 6,
    },
  });

  const salvar = (formulario) => {
    const promocaoSalvar = { ...formulario };

    if (promocao.id > 0) {
      promocaoSalvar.id = promocao.id;

      peij
        .post("assinaturas/editarPromocao", promocaoSalvar)
        .then((res) => {
          if (res.includes(200)) {
            notification("success", "Promoção salva!");

            history.goBack();
          } else {
            notification(
              "warning",
              "Não foi possível salvar a promoção. Verifique as informações."
            );
          }
        })
        .catch((e) => notification("error", "Erro ao salvar a promoção"));
    } else {
      peij
        .post("assinaturas/inserirPromocao", promocaoSalvar)
        .then((res) => {
          if (res.id && res.id > 0) {
            notification("success", "Promoção salva!");
            history.goBack();
          } else {
            notification(
              "warning",
              "Não foi possível salvar a promoção. Verifique as informações."
            );
          }
        })
        .catch((e) => notification("error", "Erro ao salvar a promoção"));
    }
  };

  const fForm = {
    form: formularioPromocao(promocao),
    submit: {
      label: "Salvar",
      action: salvar,
    },
    close: {},
    history,
  };

  return (
    <div>
      {carregando ? (
        <CircularProgress />
      ) : (
        <>
          <Form formData={fForm} />
        </>
      )}
    </div>
  );
};

export default Promocao;
